import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Space,
  Text,
  Flex,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';

interface Params {
  isVisible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  filterType: string;
}

const RetroScanEnableModal = (props: Params) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        closeOnEsc
        closeOnOutsideClick
        isClosable
        isOpen={props.isVisible}
        onClose={props.onClose}
        size="sm"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <Flex flexDirection="column">
              {props.filterType === 'webReputation' && (
                <Text>{t('policy.webReputation.retroScan.pop.descUp')}</Text>
              )}
              {props.filterType === 'advancedSpamProtection' && (
                <Text>
                  {t('policy.advancedSpamProtection.retroScan.pop.descUp')}
                </Text>
              )}
              <Text mt="24px">
                {t('policy.malwareScanning.retroScan.pop.descDown')}
              </Text>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button minWidth="20x" variant="primary" onClick={props.onConfirm}>
              {t('common.button.ok')}
            </Button>
            <Space width="2x" />
            <Button minWidth="20x" onClick={props.onClose}>
              {t('log.button.cancel')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default RetroScanEnableModal;
